import { Card } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AlertCircle, Filter, Ban } from "lucide-react";
import { BannedWordsManager } from "./BannedWordsManager";
import { BannedIPsManager } from "./BannedIPsManager";

export const SpamManagement = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Spam Management</h1>
      
      <Card className="p-6">
        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Advanced spam detection features are not yet configured. Basic spam protection through banned words and IP management is available below.
          </AlertDescription>
        </Alert>
      </Card>

      <Tabs defaultValue="banned-words">
        <TabsList>
          <TabsTrigger value="banned-words" className="flex items-center gap-2">
            <Filter className="h-4 w-4" />
            Banned Words
          </TabsTrigger>
          <TabsTrigger value="banned-ips" className="flex items-center gap-2">
            <Ban className="h-4 w-4" />
            IP Management
          </TabsTrigger>
        </TabsList>

        <TabsContent value="banned-words">
          <BannedWordsManager />
        </TabsContent>

        <TabsContent value="banned-ips">
          <BannedIPsManager />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SpamManagement;
